<template>
    <div v-if="showOtherItems">
        <!-- display component heading -->
        <div class="row">
            <div class="col-sm-10 col-12 add-ellipsis">
                <router-link :to="{ name: 'category-items', params: { category: relatedCategory } }" class="h4">
                    <i class="far fa-images"></i> <span class="text-dark-green"> Related {{relatedCategory | capitalize}} Items</span> 
                </router-link>
            </div>
            <div class="col-sm-2 text-right d-none d-sm-block">
                <router-link :to="{ name: 'category-items', params: { category: relatedCategory } }">
                    <button class="btn btn-dark-green btn-sm">See All</button>
                </router-link>
            </div>
        </div>

        <!-- display related items for desktop view alone -->
        <div v-if="relatedItemsArr.length" class="row mt-1 d-none d-lg-flex">
            <app-item v-for="(item, i) in relatedItemsArr.slice(0, 8)" :key="i" :item="item" :likes="true"></app-item>
        </div>
        
        <!-- display related items for mobile view alone -->
        <div v-if="relatedItemsArr.length" class="row mt-1 d-lg-none">
            <app-item v-for="(item, i) in relatedItemsArr.slice(0, 6)" :key="i" :item="item" :likes="true"></app-item>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Item from '../../shared/Item.vue'


export default {
    name: "RelatedItems",
    props: {
        relatedCategory: {
            type: String,
            required: true
        },
        excludeItemId: {
            type: String,
            required: true
        }
    },
    methods: {
        ...mapActions(['theRelatedItems']),
        updatePage(newRelatedCategory){
            this.theRelatedItems(newRelatedCategory).then(() => {}).catch((e) => {})
        }
    },
    computed: {
        ...mapGetters(['relatedItems']),
        filteredItemsArr() {
            // filter out the currently displaying item from the category
            if(this.relatedItems){
                let filteredItems = this.relatedItems.itemsArr.filter(item => item._id !== this.excludeItemId)
                return filteredItems
            }
            return false
        },
        showOtherItems() {
            if(this.filteredItemsArr && !this.filteredItemsArr.length){
                return false 
            }
            return true
        },
        relatedItemsArr() {
            if(this.filteredItemsArr){
                // shuffle the items here
                let itemsArr = this.filteredItemsArr
                for(let i=0; i < itemsArr.length; i++){
                    let j = Math.floor(Math.random() * i)
                    let temp = itemsArr[i]
                    itemsArr[i] = itemsArr[j]
                    itemsArr[j] = temp
                }
                return itemsArr
            }
            return false
        },
    },
    components: {
        appItem: Item
    },
    watch: {
        relatedCategory() {
            this.updatePage(this.relatedCategory)
        },
    },
    created() {
        this.updatePage(this.relatedCategory)
    }
}
</script>
